module.exports = __webpack_public_path__ + "img/17.6555ef98.png";